"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const compose_1 = __importDefault(require("utils/compose"));
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const react_1 = require("@emotion/react");
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const material_1 = require("@mui/material");
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const transactions_1 = require("companion-app-components/flux/transactions");
const scheduledTransactionsUtils_2 = require("data/scheduledTransactions/scheduledTransactionsUtils");
const utils_1 = require("data/transactions/utils");
const AmountField_1 = require("components/QuickenControls/AmountField");
const QButton_1 = __importDefault(require("components/QButton"));
const QData_1 = __importDefault(require("components/QData"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const ConfirmationDialog_1 = require("components/Dialogs/ConfirmationDialog");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useSelectOrDispatch_1 = require("./useSelectOrDispatch");
const styles_1 = __importDefault(require("./styles"));
const ScheduledTransactionFormView = ({ changeDetailsMode, onClose, upcomingTxn, classes, scheduledTransaction, }) => {
    const { categoriesById, accountsById, isEntityGroupEnabled, sharedAccounts, dispatchMakeDialog, dispatchDeleteScheduledTransactionAction } = (0, useSelectOrDispatch_1.useData)();
    const firstUpcomingTxn = (upcomingTxn === null || upcomingTxn === void 0 ? void 0 : upcomingTxn.size) > 0 && upcomingTxn.first();
    const dueOn = firstUpcomingTxn ? firstUpcomingTxn.postedOn : scheduledTransaction.dueOn;
    const dateNextUpcomingTxn = dueOn ? `Next ${luxon_1.DateTime.fromISO(dueOn).toLocaleString(luxon_1.DateTime.DATE_MED)}` : 'unknown';
    const amountNextUpcomingTxn = (firstUpcomingTxn && firstUpcomingTxn.amount) || (scheduledTransaction.transaction && scheduledTransaction.transaction.amount);
    const type = scheduledTransaction.type === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER ? 'Transfer to' : scheduledTransactionsUtils_1.STTypeNamesEnum[scheduledTransaction.type] || scheduledTransaction.type;
    const category = (0, scheduledTransactionsUtils_2.getCategoryString)(scheduledTransaction.transaction, categoriesById, isEntityGroupEnabled ? sharedAccounts : accountsById);
    let allowEditing = true;
    let disableEditButton = false;
    if (scheduledTransaction && scheduledTransaction.transaction) {
        allowEditing = ((0, utils_1.transactionEditsNotAllowed)(scheduledTransaction.transaction) === null); // isTransferTxn(scheduledTransaction.transaction) && isSupportedTransferTxn(scheduledTransaction.transaction);
        disableEditButton = (transactions_1.transactionsUtils.isTransferTxn(scheduledTransaction.transaction) && category === 'ACCOUNT NOT SYNCED');
    }
    const deleteSchTxn = () => {
        var _a;
        dispatchMakeDialog({
            id: 'delete-schedule-transaction-confirmation-form',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Delete Schedule Transaction',
                content: `Are you sure you want to delete the schedule transaction for "${(_a = scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.transaction) === null || _a === void 0 ? void 0 : _a.payee}"?`,
                confirmLabel: 'Delete Schedule Transaction',
                confirmAction: (_reason, _closeEvent) => {
                    dispatchDeleteScheduledTransactionAction((0, scheduledTransactionsTypes_1.mkScheduledTransaction)({
                        clientId: scheduledTransaction.clientId,
                        id: scheduledTransaction.id,
                        isDeleted: true,
                    }));
                    if (onClose) {
                        onClose();
                    }
                },
                denyLabel: 'Go Back',
            })),
        });
    };
    return (<>
      <RendersCount_1.default id="count-scheduled-txn-details"/>
      <div className={classes.header} id="scheduled-txn-details">
        <div className={classes.headerSpace}>
          <div />
          <material_1.IconButton id="close-button" aria-label="close view details" onClick={onClose} className={classes.closeButton} size="small">
            <Cancel_1.default />
          </material_1.IconButton>
        </div>

        <material_1.Grid container direction="row" justifyContent="space-between" alignItems="center">
          <material_1.Grid item>
            <div className={classes.ellipsedWrapText}>
              <QTip_1.default title={scheduledTransaction.transaction && scheduledTransaction.transaction.payee} wrapOnly>
                <material_1.Typography id="scheduled-txn-name" variant="h6" className={classes.ellipsedText}>
                  {scheduledTransaction.transaction && scheduledTransaction.transaction.payee}
                </material_1.Typography>
              </QTip_1.default>
            </div>
            <material_1.Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
              <material_1.Grid item>
                <material_1.Typography id="scheduled-txn-amount" classes={amountNextUpcomingTxn > 0 ? { root: classes.positiveAmount } : {}} variant="h6">
                  {(0, AmountField_1.formatNumber)(amountNextUpcomingTxn, 'USD', '0,00.00', AmountField_1.ShowSignEnum.POSITIVE_ONLY)}
                </material_1.Typography>
              </material_1.Grid>
              <material_1.Grid item>
                <material_1.Chip id="scheduled-txn-frequency" label={(0, scheduledTransactionsUtils_1.frequencyAliasFromRecurrence)(scheduledTransaction.recurrence) || 'Unknown'} className={classes.chip}/>
              </material_1.Grid>
            </material_1.Grid>
            <material_1.Typography id="scheduled-txn-next-date" className={classes.nextDate} variant="subtitle1" color="secondary">
              {dateNextUpcomingTxn}
            </material_1.Typography>
          </material_1.Grid>
          <material_1.Grid item>
            <material_1.Avatar className={classes.bigAvatar}>
              {scheduledTransaction.transaction && scheduledTransaction.transaction.payee && scheduledTransaction.transaction.payee[0]}
            </material_1.Avatar>
          </material_1.Grid>
        </material_1.Grid>
      </div>
      <div className={classes.body}>
        <material_1.Grid container direction="row" justifyContent="space-between" alignItems="center">
          <material_1.Grid item>
            <material_1.Typography className={classes.boldTypography} variant="overline">Series Settings</material_1.Typography>
          </material_1.Grid>
          {allowEditing &&
            <material_1.Grid item>
              <QTip_1.default title="You need to sync your account to the cloud before editing this transfer reminder" placement="right-start" open={disableEditButton ? undefined : false} popperProps={{
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: '-40,0',
                        },
                        flip: {
                            enabled: false,
                        },
                    },
                }}>
                <QButton_1.default id="edit-series-button" onClick={changeDetailsMode} variant="outlined" disabled={disableEditButton}>
                  Edit Series
                </QButton_1.default>
              </QTip_1.default>
              <QButton_1.default id="delete-transaction" variant="outlined" className={classes.deleteButton} onClick={deleteSchTxn}>
                <Delete_1.default />
              </QButton_1.default>
            </material_1.Grid>}
        </material_1.Grid>

        <material_1.TextField label="Type" value={type || ''} margin="dense" fullWidth InputProps={{
            readOnly: true,
            disabled: true,
            classes: {
                underline: classes.underlineOverride,
                disabled: classes.defaultOverride,
            },
        }}/>
        <material_1.TextField label={type && type.includes('Transfer') ? type : 'Category'} value={category} margin="dense" fullWidth InputProps={{
            readOnly: true,
            disabled: true,
            classes: {
                underline: classes.underlineOverride,
                disabled: classes.defaultOverride,
            },
        }}/>
      </div>
    </>);
};
exports.default = (0, compose_1.default)(react_1.withTheme, (0, QData_1.default)())((0, mui_1.withStyles)(React.memo(ScheduledTransactionFormView), styles_1.default));
